import React, { useState } from 'react';

interface SearchBarProps {
  onSearch: (searchTerm: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(searchTerm);
  };

  const handleClear = () => {
    setSearchTerm('');
    onSearch('');
  };

  const formStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    position: 'relative'
  };

  const inputStyle: React.CSSProperties = {
    backgroundColor: 'white',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    color: 'black',
    borderRadius: '4px',
    padding: '6px 10px',
    //paddingRight: '30px', // Space for clear button
    fontSize: '14px',
    outline: 'none',
    marginRight: '8px'
  };

  const clearButtonStyle: React.CSSProperties = {
    position: 'absolute',
    right: '5px', // Adjust based on search button width
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '18px',
    color: '#aaa',
    padding: '0 5px'
  };

  const searchButtonStyle: React.CSSProperties = {
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    padding: '7px 15px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 'bold',
    display: 'none'
  };

  return (
    <form onSubmit={handleSearch} style={formStyle}>
      <input
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="Search nodes by name..."
        style={inputStyle}
      />
      {searchTerm && (
        <button type="button" onClick={handleClear} style={clearButtonStyle}>
          ×
        </button>
      )}
      <button type="submit" style={searchButtonStyle}>
        Search
      </button>
    </form>
  );
};

export default SearchBar;
